import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'

const ways = [
  {
    title: 'Add a radio driver',
    body: 'Each supported radio has a driver that describes its memory layout. New drivers are the most requested contribution and often start from an existing similar model.',
  },
  {
    title: 'Fix bugs',
    body: 'Browse open reports, reproduce an issue, and submit a fix. Small, well-scoped changes are the easiest to review and merge.',
  },
  {
    title: 'Improve documentation',
    body: 'Clear docs help every new operator. Improving guides and FAQs is a great first contribution, no radio hardware required.',
  },
]

export default function DevelopersPage() {
  return (
    <ContentPage
      eyebrow="// developers"
      title="Build NewChirp with us"
      description="NewChirp is open source and community-driven. If you can write Python, test hardware, or write clearly, there's a way to contribute."
    >
      <Prose>
        <Section title="How the project is built">
          <p>
            NewChirp follows the proven architecture of the classic CHIRP project: a shared core
            handles the user interface and common logic, while per-radio drivers describe exactly
            how each model stores its memory. This separation is what lets one program support
            hundreds of radios.
          </p>
        </Section>

        <Section title="Ways to contribute">
          <div className="flex flex-col gap-4">
            {ways.map((way) => (
              <div key={way.title} className="rounded-xl border border-border bg-card p-6">
                <h3 className="text-lg font-semibold text-foreground">{way.title}</h3>
                <p className="mt-2 leading-relaxed text-muted-foreground">{way.body}</p>
              </div>
            ))}
          </div>
        </Section>

        <Section title="Getting started">
          <p>
            The best way to begin is to build from source, pick a small issue, and introduce
            yourself to the{' '}
            <Link href="/community" className="text-primary underline underline-offset-4">
              community
            </Link>
            . For anything else, reach the maintainer directly.
          </p>
          <a
            href="mailto:rick@newchirp.net"
            className="inline-flex w-fit items-center gap-2 rounded-lg border border-border bg-card px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:border-primary/40 hover:bg-secondary/60"
          >
            Contact Rick Lopez
          </a>
        </Section>
      </Prose>
    </ContentPage>
  )
}
